export enum PurchaseStage {
  Afford = 'afford',
  Offer = 'offer',
  Contract = 'contract',
  PreApproval = 'preapproval',
}
